import "../../assets/css/panel.css";
import React from 'react';
import PropTypes from 'prop-types';

const Panel = (props) => {
  const { children, imageUrl="", headerContent=null, classList="", alt="", panelRef=false } = props;

  if (panelRef !== false) {
    return ( 
      <div className={`panel panel-default ${classList}`} ref={panelRef}>
        { 
          headerContent 
            ? { headerContent }
            : null
        }
        { 
          imageUrl 
            ? <div className="panel__img panel__img--small"><img src={imageUrl} alt={alt} /></div>
            : null  
        }        
        { children }
      </div>
    );
  }

  return (
    <div className={`panel panel-default ${classList}`}>
      { 
        headerContent 
          ? { headerContent }
          : null
      }
      { 
        imageUrl 
          ? <div className="panel__img panel__img--small"><img src={imageUrl} alt={alt} /></div>
          : null  
      }        
      { children }
    </div>
  ); 
};

Panel.defaultProps = {
  classList: "",
  imageUrl: ""
};

Panel.propTypes = {
  imageUrl: PropTypes.string,
  classList: PropTypes.string
};

export default Panel;
